import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "antd";
import ResizeWrapper from "../../components/ResizeWrapper";
import HexLoader from "../../components/HexLoader";
import HexTitle from "../../components/HexTitle";
import { getLabel } from "../../hooks/use-labels";
import { prepareCards } from "./cards-utils";
import EmptyPage from "../../components/EmptyPage";
import CardsList from "./CardsList";
import _ from "lodash";
import "./styles.css";
import ConfirmationModal from "../../components/HexModal/ConfirmationModal";
import { handleError } from "../../utils/common-utils";
import { savedCardDelete, savedCardsListing } from "./api-handler";

const SavedAccounts = () => {
  const [loading, setLoading] = useState(false);
  const [cardsList, setCardsList] = useState([]);
  const [openModal, setModalOpen] = useState(false);
  const [notification, setNotification] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [cardId, setCardId] = useState("");

  useEffect(() => {
    getCards();
  }, []);

  const getCards = () => {
    setLoading(true);
    savedCardsListing()
      .then((response) => {
        const { data } = response;
        const { authorizations } = data;
        const cards = prepareCards(authorizations);
        setCardsList(cards);
        setLoading(false);
      })
      .catch(console.error);
  };

  const toggleModal = () => {
    setModalOpen((prev) => !prev);
    setCardId("");
  };

  const onDeleteIconClick = (id) => {
    setCardId(id);
    setModalOpen((prev) => !prev);
  };

  const onDelete = () => {
    setLoading(true);
    savedCardDelete(cardId)
      .then((response) => {
        const { status } = response;
        setLoading(false);
        if (status === 200) {
          getCards();
          toggleModal();
        }
      })
      .catch((error) => {
        const errorMessage = handleError(error);
        setNotification(errorMessage);
        setShowNotification(true);
        setLoading(false);
      });
  };

  const renderModal = () => {
    if (!openModal) return null;

    const modalProps = {
      title: getLabel("deleteCard"),
      onCancel: () => toggleModal(),
    };

    return (
      <ConfirmationModal
        {...modalProps}
        messageClassName="mb-1"
        confirmDescription={getLabel("deleteCardConfirmation")}
        showIcon={true}
        confirmText={getLabel("yesLabel")}
        cancelText={getLabel("noLabel")}
        onConfirm={onDelete}
        onCancel={toggleModal}
        notification={notification}
        notificationType="danger"
        showNotificationOnly={showNotification}
      />
    );
  };

  return (
    <Fragment>
      {renderModal()}
      <HexTitle
        title={getLabel("savedCardsLabel")}
        className="font-24-bold-500 mb-16"
      />
      {loading ? (
        <HexLoader />
      ) : !_.isEmpty(cardsList) ? (
        <Row>
          <Col md={18} sm={24} xs={24}>
            <ResizeWrapper
              render={(resizeWidth) => (
                <CardsList
                  cardsList={cardsList}
                  onClick={onDeleteIconClick}
                  resizeWidth={resizeWidth}
                />
              )}
            />
          </Col>
          <Col md={6} sm={24} xs={24}></Col>
        </Row>
      ) : (
        <EmptyPage
          imgSrc="/assets/icons/no-saved-accounts.png"
          title={getLabel("noSavedCard")}
          content={getLabel("noSavedCardContent")}
        />
      )}
    </Fragment>
  );
};

export default SavedAccounts;
